import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemInfoPopoverComponent } from '../../components/item-info-popover/item-info-popover.component';
import { ItemThumbnailComponent } from '../../components/item-thumbnail/item-thumbnail.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputAutocompleteComponent } from '../../components/input-autocomplete/input-autocomplete.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import {Component, OnInit, OnDestroy, inject, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import Toast from '../../services/toast.service';
import UserRestServices from '../../services/user-rest.service';
import RestService from '../../services/core-rest.service';
import ServiceRestServices from '../../services/service-rest.service';
import UserService from '../../services/user.service';
import DialogServices from '../../services/dialog.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import AppLanguageService from '../../services/app-language.service';
import { PanelDirective } from '../../directives/panel.directive';
import { Subscription } from 'rxjs';
import { ModalTotpAuthenticationComponent } from '../modal-totp-authentication/modal-totp-authentication.component';

@Component({
	standalone: true,
	selector: 'modal-profile-edit',
	templateUrl: './modal-profile-edit.component.html',
	imports: [
		CommonModule, PanelDirective, MatSelectModule, PanelDirective, 
		LowerCasePipe, TranslatePipe, ItemInfoPopoverComponent, ItemThumbnailComponent, 
		LoaderOverlayComponent, InputAutocompleteComponent, ItemErrorComponent, FormsModule 
	]
})
export class ModalProfileEditComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private toast: Toast = inject(Toast);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private restService: RestService = inject(RestService);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private userService: UserService = inject(UserService);
	private dialogServices: DialogServices = inject(DialogServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private appLanguageService: AppLanguageService = inject(AppLanguageService);
	private dialogRef = inject(MatDialogRef<ModalProfileEditComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	walletSubscription: Subscription = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.initialize();
		
		var currentEmployer = undefined;
		var currentPhone = this.vm.profile?.phone;
		this.watcher = this.angularHelperService.createInterval(() => {
			var newEmployer = this.vm.employer;
			if (!this.angularHelperService.isEqual(currentEmployer, newEmployer)) {
				currentEmployer = newEmployer ? Object.assign({}, newEmployer) : undefined;
				if (currentEmployer) {
					this.handleEmployerValidity();
				}
			}
			
			if (this.vm.profile.phone !== currentPhone) {
				currentPhone = this.vm.profile.phone;
				if (currentPhone) {
					this.handleUserPhoneNumberChanged();
				}
			}
		}, 300);
		
		this.vm.close = this.close;
		this.vm.handleEmailUpdate = this.handleEmailUpdate;
		this.vm.submit = this.submit;
		this.vm.isEmailFree = true;
		this.vm.updatePassConfErrors = this.updatePassConfErrors;
		this.vm.handleCountryCodeSearch = this.handleCountryCodeSearch;
		this.vm.handleCountryCodeSelect = this.handleCountryCodeSelect;
		this.vm.handleEmployerSearch = this.handleEmployerSearch;
		this.vm.handleElisaActivationRequest = this.handleElisaActivationRequest;
		this.vm.isEmployeeJoinRequestAllowed = this.isEmployeeJoinRequestAllowed;
		this.vm.sendEmployerJoinRequest = this.sendEmployerJoinRequest;
		this.vm.checkEmployerStatus = this.checkEmployerStatus;
		this.vm.clearEmployerSearch = this.clearEmployerSearch;
		this.vm.clearCountryCodeSearch = this.clearCountryCodeSearch;
		this.vm.handleDeleteMyAccount = this.handleDeleteMyAccount;
		this.vm.requestVerificationCode = this.requestVerificationCode;
		this.vm.validateVerificationCode = this.validateVerificationCode;
		this.vm.enable2FaAuthentication = this.enable2FaAuthentication;
		this.vm.enableTotpAuthentication = this.enableTotpAuthentication;
		this.vm.showCountDownTimer = this.showCountDownTimer;
		this.vm.enableNotificationViaEmail = this.enableNotificationViaEmail;
		this.getChatNotificationStatus();
	}
	
	ngOnDestroy() {
		if (this.walletSubscription) {
			this.walletSubscription.unsubscribe();
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	initialize() {
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig().LOADER_TIMEOUT_INIT);
		this.vm.user = this.session.getSession().user;
		var origin: any = (this.vm.user && this.vm.user.origin) ? this.vm.user.origin : "minudoc.ee";
		this.vm.uid = 'pe-' + Date.now();
		this.vm.isSignupCompleted = this.vm.user.signupCompleted || this.vm.user.businessUserType === 'SERVICE_OWNER'
			|| this.vm.user.businessUserType === 'BUSINESS_CLIENT';
		this.vm.isRegularUser = !this.vm.user.businessUserType;
		this.vm.isBusinessUser = (this.vm.user.businessUserType === 'BUSINESS_CLIENT' || this.vm.user.businessUserType === 'SERVICE_OWNER');
		this.vm.hasPassword = (origin == 'siffi.com' || !this.vm.user.personalCode);
		this.vm.isMinudocUser = (origin == 'minudoc.ee' && this.vm.user.personalCode != null);
		this.vm.profile = this.angularHelperService.copy(this.vm.user);
		this.vm.profile.birthDate = this.vm.profile.birthDate ? new Date(this.vm.profile.birthDate) : undefined;
		this.vm.language = this.angularHelperService.copy(this.vm.profile.deviceLanguage);
		this.vm.deviceLanguages = this.appLanguageService.getLanguagesByOrigin(origin);
		this.vm.countryPhoneCodes = this.config.getSettings().CountryPhoneCodes;
		this.vm.webUrl = this.config.getPublicWebUrl();
		this.vm.password = {};
		this.vm.disallowedEmailDomains = ['eesti.ee'];
		this.vm.processingEmployerStatusCheck = false;
		this.vm.sendingEmployerJoinRequest = false;
		this.vm.employerSubmitInvalid = false;
		this.vm.isElisaConsentConfirmed = false;
		this.vm.isElisaActivationRequestSent = false;
		this.vm.processingMobilePackageCheck = false;
		this.vm.hasElisaBusinessWallet = false;
		this.vm.elisaPackage='';
		this.vm.elisaPackageList = [];
		this.vm.countryCode = this.defineCountryCode(this.vm.profile.countryCode, this.vm.profile.phone);
		this.vm.isChatNotificationEnabled = this.vm.user.chatNotificationEnabled ? this.vm.user.chatNotificationEnabled : false;
		this.vm.enableChatNotification = this.vm.isChatNotificationEnabled;
		this.vm.is2faEnabled = !!this.vm.user.twoFaEnabled;
		this.vm.isTotpEnabled = !!this.vm.user.totpAuthEnabled;
		this.vm.isPhoneVerified = !!this.vm.user.phoneNumberVerified;
		this.vm.enable2faAuth = this.vm.is2faEnabled;
		this.vm.enableTotpAuth = this.vm.isTotpEnabled;
		this.vm.isVerificationCodeCorrect = true;
		this.vm.isPhoneNumberExists = !!this.vm.user.phone && !!this.vm.user.phone.match(/^[0-9 +)]+$/);
		this.vm.showCounter = true;
		this.vm.showResendButton = false;
		this.vm.seconds = 59;
		this.vm.enable2faAuthButtonVisible = false;
		this.vm.enableTotpAuthButtonVisible = false;
		this.vm.enableChatNotificationButtonVisible = false;
		var location: any = window.location.href;
		var locale: any = this.vm.user?.deviceLanguage;
		if (location.includes('eelvisiit')) {
			this.vm.previsitLocation = true;
		}
		
		this.getBusinessClientWallets('Elisa');
		
		if (origin == 'minudoc.ee') {
			switch (this.vm.user.deviceLanguage) {
				case 'et_EE':
				this.vm.webPathTos = '/kasutustingimused';
				this.vm.webPathPP = '/privaatsuspoliis';
				break;
				case 'ru_RU':
				this.vm.webPathTos = '/uslovija-ispolzovanija';
				this.vm.webPathPP = '/politika-konfidencialnosti';
				break;
				case 'fi_FI':
				this.vm.webPathTos = '/kayttoehdot';
				this.vm.webPathPP = '/tietosuojakaytanto';
				break;
				default:
				this.vm.webPathTos = '/terms-of-service';
				this.vm.webPathPP = '/privacy-policy';
			}
		} else {
			this.vm.webPathTos = '/terms-of-service';
			this.vm.webPathPP = '/privacy-policy';
		}
		this.vm.webTosLink = origin == 'siffi.com'
			? this.config.getSiffiPublicWebUrl(locale, this.vm.webPathTos)
			: this.vm.webUrl + this.vm.webPathTos;
		this.vm.webPPLink = origin == 'siffi.com'
			? this.config.getSiffiPublicWebUrl(locale, this.vm.webPathPP)
			: this.vm.webUrl + this.vm.webPathPP;
		this.vm.ppConsent = this.angularHelperService.trustAsHtml(
			this.angularFilterHelperService.translate('Modal.Content.HaveRead')
				.replace('%s', '<a href="' + this.vm.webPPLink +'" target="_blank">' + this.angularFilterHelperService.translate('Modal.Content.PrivacyPolicy') + '</a>')
		);
		this.vm.tosConsent = this.angularHelperService.trustAsHtml(
			this.angularFilterHelperService.translate('Modal.Content.AgreeTo')
				.replace('%s', '<a href="' + this.vm.webTosLink +'" target="_blank">' + this.angularFilterHelperService.translate('Modal.Content.ToS') + '</a>')
		);
		
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) this.angularHelperService.createTimer(() => { this.vm.processing = false; },
			this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
		
		//this.angularStateHelperService.scopeWF(this, this.userService.getWallet, this.handleWalletUpdate, true);
		this.broadcastSubscriptions.push(
			this.walletSubscription = this.angularBroadcastHelperService.onEvent(this, "walletChanged",
				(event, newWallet) => {
					this.handleWalletUpdate(newWallet);
				}
			)
		);
		
		var loadedWallet = this.userService.getWallet(); // TODO ANGULAR_2: should this be inside an interval?
		this.handleWalletUpdate(loadedWallet);
		
		this.vm.initialized = true;
	}
	
	handleCountryCodeSearch = (searchParams: any): void => {
		var namePart = searchParams.namePart;
		
		var countryCodes: any = this.vm.countryPhoneCodes.filter((item) => {
			return item.country.toLowerCase().indexOf(namePart.toLowerCase()) !== -1
				|| item.dialCode.toLowerCase().indexOf(namePart.toLowerCase()) !== -1
				|| item.countryCode.toLowerCase().indexOf(namePart.toLowerCase()) !== -1;
		});
		countryCodes.sort((a, b) => {
			return a.dialCode.length > b.dialCode.length || a.dialCode.localeCompare(b.dialCode);
		});
		var deferred: any = this.angularHelperService.getDeferredPromise();
		deferred.resolve(countryCodes.slice(0, countryCodes.length < 10 ? countryCodes.length : 10));
		return deferred.promise;
	}
	
	handleUserPhoneNumberChanged() {
		this.vm.isUserPhoneChanged = (this.vm.profile.countryCode + this.vm.profile.phone) !== this.vm.user.phone;
		this.vm.isPhoneVerified = false;
	}
	
	isPhoneNumberAdded() {
		return this.vm.countryCode?.dialCode && this.vm.profile.phone;
	}
	
	handleCountryCodeSelect = (selectedCountryCode: any): void => {
		this.vm.countryCode = this.angularHelperService.copy(selectedCountryCode.selectedItem);
		this.vm.countryCode.name = this.vm.countryCode.dialCode;
		if (this.vm.profile.countryCode !== this.vm.profile.countryCode) {
			this.vm.isUserPhoneChanged = true;
		} else {
			this.vm.isUserPhoneChanged = (this.vm.countryCode.dialCode + this.vm.profile.phone) !== this.vm.user.phone;
		}
		this.vm.isPhoneVerified = false;
	}
	
	clearCountryCodeSearch = () => {
		this.vm.countryCode = undefined;
	}
	
	enableNotificationViaEmail() {
		this.vm.enableChatNotificationButtonVisible = false;
		this.userRestServices.enableChatNotification(
			{
				userId: this.vm.user.id,
				enableChatNotification: this.vm.enableChatNotification
			},
			(res) => {
				this.vm.enableChatNotification = res.chatNotificationEnabled;
				if (this.vm.enableChatNotification) {
					this.vm.isChatNotificationEnabledInfo = true;
					this.vm.isChatNotificationDisabledInfo = false;
				} else {
					this.vm.isChatNotificationDisabledInfo = true;
					this.vm.isChatNotificationEnabledInfo = false;
				}

			}, (err) => {
				console.log(err);
				this.vm.enableChatNotificationButtonVisible = true;
			}
		);
	}
	
	getChatNotificationStatus() {
		this.userRestServices.getChatNotificationStatus({ userId: this.vm.user.id },
			(res) => {
				this.vm.isChatNotificationEnabledGlobally = (res.setting.value === "true");
				this.vm.user.chatNotificationEnabled = res.enabledForUser;
				this.vm.isChatNotificationEnabled = this.vm.user.chatNotificationEnabled ? this.vm.user.chatNotificationEnabled : false;
				this.vm.enableChatNotification = this.vm.isChatNotificationEnabled;
			},
			(err) => {
				console.log(err);
			}
		);
	}
	
	handleDeleteMyAccount() {
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
			content: this.angularFilterHelperService.translate('Modal.Content.Delete_My_Account_Confirmation'),
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {
				this.serviceRestServices.deleteMyAccount(
					() => {
						this.session.logout();
					},
					() => {
						this.session.logout();
					}
				);
			}
		});
	}
	
	handleEmployerSearch = (searchParams: any): void => {
		var namePart = searchParams.namePart;
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.restService.getBusinessClientSearch({ name: namePart })
			.then((items) => {
				this.vm.isEmployerPanelOverflowVisible = true;
				var employers: any = items.map((item, index) => {
					item.id = index + 1;
					return item;
				});
				deferred.resolve(employers);
			})
			.catch((err) => {
				console.error(err);
				deferred.reject(err);
			});
		
		return deferred.promise;
	}
	
	handleEmployerValidity() {
		this.vm.isEmployerPanelOverflowVisible = false;
		this.vm.employerSubmitInvalid = false;
		if (!this.vm.employer) return;
		
		var isIntegrationValid: any = this.vm.employer ? !!this.vm.employer.configId : true;
		this.vm.isIntegrationValid = isIntegrationValid;
	}
	
	isEmployeeJoinRequestAllowed() {
		return this.vm.employer && this.vm.employer['allowEmployeeJoinRequest'];
	}
	
	sendEmployerJoinRequest(mainForm: any) {
		if (!this.vm.employer) {
			this.vm.employerSubmitInvalid = true;
			return;
		}
		if (this.vm.sendingEmployerJoinRequest) {
			return;
		}
		this.vm.employerSubmitInvalid = false;
		this.vm.sendingEmployerJoinRequest = true;
		var joinRequestData = {
			platform: 'BROWSER',
			employer: {
				id: this.vm.employer['businessUserId']
			}
		};
		this.restService.saveBusinessUserJoinRequests(joinRequestData)
			.then((response) => {
				this.vm.sendingEmployerJoinRequest = false;
				this.vm.close();
			})
			.catch((error) => {
				this.vm.sendingEmployerJoinRequest = false;
				console.log(error);
			});
	}
	
	clearEmployerSearch = () => {
		this.vm.employer = undefined;
		this.vm.employerSearchConsent = false;
		this.vm.employerSubmitInvalid = false;
	}
	
	checkEmployerStatus(mainForm: any) {
		if (!this.vm.employer || !this.vm.employerSearchConsent) {
			this.vm.employerSubmitInvalid = true;
			return;
		}
		if (this.vm.processingEmployerStatusCheck) {
			return;
		}
		this.vm.employerSubmitInvalid = false;
		this.vm.processingEmployerStatusCheck = true;
		this.restService.getBusinessClientWorkerCheck({ configId: this.vm.employer.configId })
			.then((res) => {
				this.session.updateSession(res);
				this.vm.user = this.session.getSession().user;
				this.vm.processingEmployerStatusCheck = false;
			})
			.catch((err) => {
				this.toast.showWithTranslation('Toast.Profile.Employer_Check_Failed');
				this.vm.processingEmployerStatusCheck = false;
			});
	}
	
	requestVerificationCode() {
		this.vm.isVerificationProcess = true;
		this.userRestServices.requestVerificationCode({ userId: this.vm.user.id },
			(res) => {
				console.log("Status 200 in this.requestVerificationCode()");
				this.showCountDownTimer();
			},
			(err) => {
				console.log(err);
				this.showCountDownTimer();
			}
		);
	}
	
	validateVerificationCode() {
		this.userRestServices.validateVerificationCode(
			{
				userId: this.vm.user.id,
				verificationCode: this.vm.verificationCode
			},
			(res) => {
				console.log("Status 200 in this.validateVerificationCode()");
				this.vm.isVerificationCodeCorrect = true;
				this.vm.isVerificationProcess = false;
				this.vm.isPhoneVerified = res.phoneNumberVerified;
				console.log(res.phoneNumberVerified);
			},
			(err) => {
				console.log(err);
				this.vm.isVerificationCodeCorrect = false;
			}
		);
	}
	
	enable2FaAuthentication() {
		this.vm.enable2faAuthButtonVisible = false;
		this.userRestServices.enable2FaAuthentication(
			{
				userId: this.vm.user.id,
				enable2faAuth: this.vm.enable2faAuth
			},
			(res) => {
				this.vm.enable2faAuth = res.twoFaEnabled;
				if (this.vm.enable2faAuth) {
					this.vm.is2faEnabledInfo = true;
					this.vm.is2faEnabled = true;
				} else {
					this.vm.is2faDisabledInfo = true;
					this.vm.is2faEnabled = false;
				}
			},
			(err) => {
				console.log(err);
				this.vm.enable2faAuthButtonVisible = true;
			}
		);
	}

	enableTotpAuthentication() {
		this.vm.enableTotpAuthButtonVisible = false;
		this.userRestServices.generateTotpSecretKey(
				{
					userId: this.vm.user.id,
					enableTotpAuth: this.vm.enableTotpAuth
				},
				(res) => {
					this.vm.enableTotpAuth = res.user.totpSecretKey != null;
					if (this.vm.enableTotpAuth) {
						var dialog = this.dialogServices.show({
							controller: ModalTotpAuthenticationComponent,
							qrCodeImage: res.qrCodeImage,
							showInstruction: true,
							width: '500px',
							clickOutsideToClose: false,
							escapeToClose: false,
							multiple: false
						});
						dialog.afterClosed().subscribe(
							(data) => {
								if (data === 'SUCCESS') {
									this.vm.isTotpEnabledInfo = true;
									this.vm.isTotpEnabled = true;
								}
							},
							() => {}
						);
					} else {
						this.vm.isTotpDisabledInfo = true;
						this.vm.isTotpEnabled = false;
					}
				},
				(err) => {
					console.log(err);
					this.vm.enableTotpAuthButtonVisible = true;
				}
			);
	}
	
	showCountDownTimer() {
		this.vm.seconds = 59;
		this.vm.showCounter = true;
		this.vm.showResendButton = false;
		this.tick();
	}
	
	tick() {
		var counter: any = document.getElementById("counter");
		this.vm.seconds--;
		if (counter !== null) {
			counter.innerHTML = (this.vm.seconds < 10 ? "0" : "") + String(this.vm.seconds);
		}
		if (this.vm.seconds > 0) {
			setTimeout(() => {
				this.tick();
			}, 1000);
		} else {
			this.vm.showResendButton = true;
			this.vm.showCounter = false;
		}
	}
	
	getBusinessClientWallets(groupName) {
		this.restService.getElisaPackagesList({ groupName: groupName })
			.then((response) => {
				this.vm.elisaPackageList = response.filter((item) => {
					return item['walletType'] === 'MOBILE_PACKAGE';
				});
				this.vm.elisaPackage = (response[0] || {});
			})
			.catch((error) => {
				console.log(error);
			});
	}
	
	defineCountryCode(countryCode, phoneNumber) {
		var processedCountryCode: any = undefined;
		if (countryCode) {
			var processedCountryCodeNumbers: any = (countryCode || '').match(/\d/g);
			processedCountryCode = processedCountryCodeNumbers ? processedCountryCodeNumbers.join('') : undefined;
		}
		var processedNumber: any = undefined;
		if ('-' === phoneNumber) {
			processedNumber = "";
		} else if (phoneNumber) {
			var processedNumberNumbers: any = (phoneNumber || '').match(/\d/g);
			processedNumber = processedNumberNumbers ? processedNumberNumbers.join('') : undefined;
		}
		
		var countryCodes: any = this.vm.countryPhoneCodes.filter((item) => {
			var processedCode: any = ((item.dialCode || '').match(/\d/g)).join('');
			if (processedCountryCode) {
				return parseInt(processedCountryCode) === parseInt(processedCode);
			} else {
				return processedNumber && processedNumber.startsWith(processedCode);
			}
		}) || [];
		
		if (countryCodes.length > 0) {
			var countryCode: any = this.angularHelperService.copy(countryCodes[0]);
			countryCode.name = countryCode.dialCode;
			var processedCode: any = ((countryCode.dialCode || '').match(/\d/g)).join('');
			if (!processedCountryCode || (!!processedCountryCode && processedNumber.startsWith(processedCountryCode))) {
				this.vm.profile.phone = processedNumber.slice(processedCode.length);
			}
			return countryCode;
		}
		return undefined;
	}
	
	handleWalletUpdate(wallet) {
		if (this.angularHelperService.equals(wallet, this.vm.wallet)) return;
		this.vm.wallet = wallet || {};
		var elisaBusinessWallet: any = (this.vm.wallet['alternatives'] || []).find((wallet) => {
			return wallet.name === 'Elisa';
		});
		if (elisaBusinessWallet) {
			this.vm.hasElisaBusinessWallet = true;
		}
	}
	
	handleElisaActivationRequest() {
		if (this.vm.processingMobilePackageCheck) {
			return;
		}
		this.vm.processingMobilePackageCheck = true;
		
		var packageRequestData = {
			employee: {
				id: this.vm.user.id
			},
			employer: {
				id: this.vm.elisaPackage.businessService.user.id
			},
			origin: this.vm.user.origin,
			platform: 'BROWSER'
		};
		this.restService.saveElisaPackageActivationRequest(packageRequestData)
			.then((response) => {
				this.vm.isElisaActivationRequestSent = true;
				if (response.status == 'ACCEPTED') {
					// reload the full page to make sure, that any route that might be in the background
					// gets updated with the new status of the user
					window.location.reload();
				} else if (response.status == 'REJECTED') {
					this.vm.isElisaActivationRequestSent = false;
					this.vm.joinRequestRejected = true;
				}
				this.vm.processingMobilePackageCheck = false;
			})
			.catch((error) => {
				this.vm.isElisaActivationRequestSent = false;
				this.vm.processingMobilePackageCheck = false;
			});
	}
	
	submit(mainForm: any) {
		this.handleEmailDomainValidity();
		this.vm.submitted = true;
		if (mainForm.invalid || this.vm.processing || !this.vm.initialized || !this.vm.isDomainValid) return;
		this.vm.processing = true;
		
		var promises: Array<any> = [];
		promises.push(this.updateProfile());
		if (this.vm.isSignupCompleted && this.vm.hasPassword) promises.push(this.updatePassword());
		if (this.vm.isSignupCompleted && this.vm.isRegularUser && !this.vm.user.parentBusinessUser && this.vm.isEmployerPanelOpen) {
			promises.push(this.updateEmployer());
		}
		
		this.angularHelperService.getPromise().all(promises)
			.then(
				(res) => {
					// new logic always reload page, as various changes can have effect on wallets etc.
					window.location.reload();
				},
				(err) => {
					this.vm.processing = false;
				}
			);
	}
	
	updatePassword() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		if (!this.vm.password.newPassword || !this.vm.password.newPassword.trim()) {
			deferred.resolve();
		} else {
			this.userRestServices.updatePassword(this.vm.password,
				(newPass) => {
					deferred.resolve(newPass);
				},
				(err) => {
					this.toast.showWithTranslation('Toast.Profile.Password_Update_Failed');
					deferred.reject('components/modal-profile-edit updatePassword - failed to update password');
				}
			);
		}
		return deferred.promise;
	}
	
	updateProfile() {
		this.vm.isEmailFree = true;
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.userRestServices.validateEmail(this.vm.profile.email,
			() => {
				var processedNumber: any = (!this.vm.profile.phone || '-' === this.vm.profile.phone)
					? '-' : ((this.vm.profile.phone || '').match(/\d/g)).join('');
				if (!this.vm.isBusinessUser) {
					if (!this.vm.countryCode) {
						deferred.reject('components/modal-profile-edit updateProfile - countryCode not valid!');
						return;
					}
					var countryCode: any = (this.vm.countryCode.dialCode || '');

					this.vm.profile.countryCode = countryCode;
					this.vm.profile.phone = ('-' === processedNumber)
						? '-'
						: countryCode + (processedNumber && processedNumber.length > 0 ? processedNumber : '-');
				}

				this.userRestServices.update(this.vm.profile,
					(res) => {
						deferred.resolve(res);
					},
					() => {
						this.vm.profile.phone = processedNumber;
						this.toast.showWithTranslation('Toast.Profile.Update_Failed');
						deferred.reject('components/modal-profile-edit updateProfile - failed to update profile');
					}
				);
			},
			() => {
				this.vm.isEmailFree = false;
				deferred.reject('components/modal-profile-edit updateProfile - e-mail not valid');
			}
		);
		
		return deferred.promise;
	}
	
	updateEmployer() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.restService.getBusinessClientWorkerCheck({ configId: this.vm.employer.configId })
			.then((res) => {
				this.session.updateSession(res);
				deferred.resolve(res);
			})
			.catch((err) => {
				this.toast.showWithTranslation('Toast.Profile.Employer_Check_Failed');
				deferred.reject('components/modal-profile-edit updateEmployer - ' + err);
			});
		
		return deferred.promise;
	}
	
	updatePassConfErrors() {
		this.vm.passwordMismatch = !(this.vm.password.newPassword === this.vm.password.newPasswordConfirm);
	}
	
	handleEmailUpdate() {
		this.vm.isEmailFree = true;
		this.handleEmailDomainValidity();
	}
	
	handleEmailDomainValidity() {
		if (this.vm.profile && this.vm.profile.email) {
			var emailDomain: any = this.vm.profile.email.split('@').pop();
			var isDomainValid: any = this.vm.disallowedEmailDomains.indexOf(emailDomain) === -1;
			if (!isDomainValid) this.vm.emailDomainError = this.angularFilterHelperService.translate('Errors.Invalid_Domain')
				.replace('%s', emailDomain);
			this.vm.isDomainValid = isDomainValid;
		} else {
			this.vm.isDomainValid = true;
		}
	}
	
	close() {
		this.dialogRef.close(this.vm.user);
	}
	
}
